

import React, { useState } from 'react';

interface Props {
  onAddToSheet3: (row: string[]) => void;
}

const NotCallOffForm: React.FC<Props> = ({ onAddToSheet3 }) => {
  const [comboTerms, setComboTerms] = useState('');
  const [masterTerms, setMasterTerms] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const comboList = comboTerms.split(',').map(t => t.trim()).filter(Boolean);
    const masterList = masterTerms.split(',').map(t => t.trim()).filter(Boolean);

    if (comboList.length === 0 || masterList.length === 0) {
      alert('Please provide at least one combo term and one master term');
      return;
    }

    const paddedCombo = [...comboList, '', '', ''].slice(0, 3);
    const paddedMaster = [...masterList, '', '', ''].slice(0, 3);
    const finalRow = ['', '', 'not a call-off', ...paddedCombo, ...paddedMaster];

    onAddToSheet3(finalRow);

    setComboTerms('');
    setMasterTerms('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <input
        type="text"
        placeholder="Combo terms (comma-separated)"
        value={comboTerms}
        onChange={(e) => setComboTerms(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Master terms (comma-separated)"
        value={masterTerms}
        onChange={(e) => setMasterTerms(e.target.value)}
        required
      />
      <button type="submit">Add Not a Call-off</button>
    </form>
  );
};

export default NotCallOffForm;